export default function DeleteIcon({ className="", onClick=null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M384.35,115.65c-17.94-17.94-38.85-31.85-61.6-41.28-22.76-9.43-47.38-14.37-72.75-14.37-50.75,0-98.47,19.77-134.35,55.65-35.88,35.88-55.65,83.6-55.65,134.35s19.77,98.47,55.65,134.35c35.88,35.88,83.6,55.65,134.35,55.65s98.47-19.77,134.35-55.65c35.88-35.88,55.65-83.6,55.65-134.35s-19.77-98.47-55.65-134.35ZM250,414.93c-90.95,0-164.93-73.98-164.93-164.93S159.05,85.07,250,85.07s164.93,73.98,164.93,164.93-73.98,164.93-164.93,164.93Z"/>
      <path d="M339.34,250c0,6.91-5.62,12.53-12.53,12.53h-153.62c-6.91,0-12.54-5.62-12.54-12.53s5.63-12.53,12.54-12.53h153.62c6.91,0,12.53,5.62,12.53,12.53Z"/>
    </svg>
  );
}
